// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { skaleTitanTestnet as _skaleTitanTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the skaleTitanTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1020352220
 * Chain Name: SKALE Titan Hub
 * Default Block Explorer: https://aware-fake-trim-testnet.explorer.testnet.skalenodes.com
 * Default RPC URL: https://testnet.skalenodes.com/v1/aware-fake-trim-testnet
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { skaleTitanTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: skaleTitanTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const skaleTitanTestnet = createCommon({
	..._skaleTitanTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
